import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Action } from '../models/action/action.model';

@Injectable({
	providedIn: 'root'
})
export class ActionsService {
	private actionSubject = new BehaviorSubject<Action | undefined>(undefined);
	public currentAction$: Observable<Action | undefined> = this.actionSubject.asObservable();

	set(action: Action): void {
		this.actionSubject.next(action);
	}

	clear(): void {
		this.actionSubject.next(undefined);
	}

	get(): Action | undefined {
		return this.actionSubject.value;
	}
}